<div class="snackbar">
  <mat-icon class="mat-icon-close" (click)="snackBarRef.dismiss()">close</mat-icon>
  <div>{{ title | translate }}</div>
  <mat-progress-bar [value]="progressValue" [mode]="'determinate'"></mat-progress-bar>
</div>
